export default __webpack_public_path__ + "58d2a86b6bf6d1834fea27174d2dc34b.png";